// extracted by mini-css-extract-plugin
export var cta = "LinksSection-module--cta--01d0c";
export var intro = "LinksSection-module--intro--4025b";
export var linkSectionCard = "LinksSection-module--linkSectionCard--761e0";
export var linkSectionWrapper = "LinksSection-module--linkSectionWrapper--6d4d3";
export var linkWrapper = "LinksSection-module--linkWrapper--98b34";
export var title = "LinksSection-module--title--0acbc";